export default {
  selection: "System Language Selection",
  english: "English",
  simplified_chinese: "中文（简体）",
  list: {
    en: "ইংরেজি",
    zh: "চীনা (চীন)",
    tw: "চীনা (তাইওয়ান)",
    vi: "ভিয়েতনামিজ",
    th: "থাই",
    id: "ইন্দোনেশীয়",
    malay: "মালয়",
    jp: "জাপানিজ",
    kr: "কোরিয়ান",
    my: "মিয়ানমার",
    ar: "আর্জেন্টিনা",
    ru: "রাশিয়ান",
    ne: "নেপালি",
    bn: "বাংলা"
  }
};
